module.exports = __webpack_public_path__ + "img/ladybird.2507862f.svg";